import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'

import { isAuthenticated$ } from 'src/store/modules/user'

const withOutAuthentication = (Component) => {
  function withOutAuthenticationWrapper(props) {
    const { isAuthenticated, location } = props
    const { state } = location

    if (!isAuthenticated) {
      return <Component {...props} />
    }

    return <Redirect to={state && state.referrer ? state.referrer : '/'} />
  }

  withOutAuthenticationWrapper.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.shape({
      state: PropTypes.shape({
        referrer: PropTypes.shape({
          pathname: PropTypes.string.isRequired
        }).isRequired
      })
    }).isRequired
  }

  return withOutAuthenticationWrapper
}

const mapStateToProps = (state) => ({
  isAuthenticated: isAuthenticated$(state)
})

export default compose(connect(mapStateToProps), withOutAuthentication)
